export default "__VITE_ASSET__DWS4pCrA__"